import { useEffect, useState } from "react";
import AutoCompleteUIDTO from "../dto/AutoCompleteUIDTO";
import PagedResult from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/PagedResult";
import NotificationService from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/NotificationService";
import { trace } from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/utils/Logging";
import Site from "../models/Site";
import ProjectService from "../services/ProjectService";
import SiteService from "../services/SiteService";
import RoleUtils from "../utils/RoleUtils";

export const useSiteList = () => {
  const [search, setSearch] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [searchRoleKey, setSearchRoleKey] = useState<AutoCompleteUIDTO>({ externalId: "All", label: "All" });
  const [selectedSite, setSelectedSite] = useState<Site | undefined>(undefined);
  const [projects, setProjects] = useState<AutoCompleteUIDTO[]>([]);
  const [projectsManager, setProjectsManager] = useState<AutoCompleteUIDTO[]>([]);
  const [viewSite, setViewSite] = useState<Site | undefined>();
  const [editSite, setEditSite] = useState<Site | undefined>();
  const [editMode, setEditMode] = useState<boolean>(false);
  const [result, setResult] = useState<number>();

  const handleOnDeleteSite = async () => {
    if (!selectedSite) return;

    try {
      await SiteService.delete(selectedSite);
      setSelectedSite(undefined);
      NotificationService.info("Site deleted successfully");
    } catch (error) {
      NotificationService.error("Error trying to delete a site");
    }
  };

  const handleOpenViewDialog = (site: Site) => {
    setViewSite(site);
  };

  const handleOpenEditDialog = (site: Site) => {
    setEditSite(site);
  };

  const getProjectNames = () => {
    if (RoleUtils.isAdmin()) {
      ProjectService.findProjectNames()
        .then((result) => {
          setProjects(result.getContent());
        })
        .catch((error) => trace("Error getting project names", error));
    } else if (RoleUtils.isManager()) {
      ProjectService.findProjectsNamesByUserManagerExternalId()
        .then((result) => {
          setProjectsManager(result.getContent());
        })
        .catch((error) => trace("Error getting project names", error));
    }
  };

  const getRecommendedSites = async (page: number, pageSize: number): Promise<PagedResult<Site>> => {
    const recommendedSites: PagedResult<Site> = (await SiteService.getByProjectAndRole(page, pageSize)).getContent();
    setResult(recommendedSites.totalElements);
    return recommendedSites;
  };

  const projectsAdminManager = [...projects, ...projectsManager];

  return {
    siteActions: {
      search,
      setSearch,
      isLoading,
      setIsLoading,
      editMode,
      setEditMode,
      searchRoleKey,
      selectedSite,
      setSelectedSite,
      handleOnDeleteSite,
      getProjectNames,
      projects,
      projectsManager,
      handleOpenViewDialog,
      handleOpenEditDialog,
      viewSite,
      setViewSite,
      setEditSite,
      editSite,
      projectsAdminManager,
      result,
      getRecommendedSites,
    },
  };
};
